var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.email,
                expression: "email",
                modifiers: { trim: true }
              }
            ],
            ref: "email",
            staticClass: "email",
            attrs: { type: "text", placeholder: "Email", maxlength: "30" },
            domProps: { value: _vm.email },
            on: {
              input: function($event) {
                if ($event.target.composing) return
                _vm.email = $event.target.value.trim()
              },
              blur: function($event) {
                return _vm.$forceUpdate()
              }
            }
          }),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.pwd,
                expression: "pwd",
                modifiers: { trim: true }
              }
            ],
            ref: "email",
            staticClass: "pwd",
            attrs: {
              type: "password",
              placeholder: "Password",
              minlength: "6",
              maxlength: "20"
            },
            domProps: { value: _vm.pwd },
            on: {
              input: function($event) {
                if ($event.target.composing) return
                _vm.pwd = $event.target.value.trim()
              },
              blur: function($event) {
                return _vm.$forceUpdate()
              }
            }
          }),
          _c(
            "div",
            { staticClass: "forgot", on: { click: _vm.onClickForgot } },
            [_vm._v("Forgot password?")]
          ),
          _c(
            "van-button",
            {
              directives: [{ name: "waves", rawName: "v-waves" }],
              staticClass: "button-login",
              attrs: { type: "default" },
              on: { click: _vm.onClickLogin }
            },
            [_vm._v("\n      Log in\n    ")]
          ),
          _c("div", { staticClass: "apply", on: { click: _vm.onClickApply } }, [
            _vm._v("\n      No account? "),
            _c("span", [_vm._v("Apply >")])
          ])
        ],
        1
      ),
      _c(
        "van-popup",
        {
          staticClass: "tips-popup",
          style: { width: "88%" },
          attrs: { round: "" },
          model: {
            value: _vm.showTips,
            callback: function($$v) {
              _vm.showTips = $$v
            },
            expression: "showTips"
          }
        },
        [
          _c("div", { staticClass: "header" }, [_vm._v("Tips")]),
          _c(
            "div",
            { staticClass: "content" },
            [
              _c("div", { staticClass: "content-msg" }, [
                _vm._v(_vm._s(_vm.tipsMsg))
              ]),
              _c(
                "van-button",
                {
                  directives: [{ name: "waves", rawName: "v-waves" }],
                  staticClass: "content-button",
                  attrs: { type: "default" },
                  on: { click: _vm.onClickTipsOK }
                },
                [_vm._v("\n        OK\n      ")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header" }, [
      _c("img", {
        attrs: { src: require("@/assets/logo/logo_wave_writer.png") }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }